import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || `http://localhost:3001/api`;

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export async function recordGuess(artist: string, isCorrect: boolean): Promise<void> {
  try {
    // Call metrics (alias) to avoid ad blockers interfering
    await apiClient.post('/metrics', { artist, isCorrect });
  } catch (error) {
    // Non-fatal: ignore in UI, log for diagnostics
    console.warn('Failed to record stats', error);
  }
}

export async function getStats(artist: string): Promise<{ attempts: number; correct: number; rate: number }> {
  const { data } = await apiClient.get(`/metrics/${encodeURIComponent(artist)}`);
  return data;
}

export default { recordGuess, getStats };


